import { assertWriteIdentity, captureWriteIdentity, fillPath, getBlob, getJson, sendJson, type WriteIdentity } from "./http";

export type TabellenZaehlung = Record<string, number>;

export type LoeschErgebnis = {
  ausgefuehrt: boolean;
  geloescht: TabellenZaehlung;
  bleibt: TabellenZaehlung;
  dateien: number;
};

export const TEILNEHMENDE_TABELLE = "core.teilnehmende";

export type TestdatenDatei = "klett-ergebnis.pdf" | "geva-dossier.pdf" | "unterschrift.png";

const MIME: Record<TestdatenDatei, string> = {
  "klett-ergebnis.pdf": "application/pdf",
  "geva-dossier.pdf": "application/pdf",
  "unterschrift.png": "image/png",
};

export async function testdatenVerfuegbar(): Promise<boolean> {
  try {
    const body = await getJson<{ verfuegbar?: unknown } | null>("/testdaten");
    return body?.verfuegbar === true;
  } catch {
    return false;
  }
}

function isZaehlung(value: unknown): value is TabellenZaehlung {
  return (
    !!value &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    Object.values(value).every((n) => typeof n === "number")
  );
}

export async function teilnehmendeLoeschen(ausfuehren: boolean, identity: WriteIdentity = captureWriteIdentity()): Promise<LoeschErgebnis> {
  const body = await sendJson<Partial<LoeschErgebnis> | null>("/testdaten/teilnehmende-loeschen", "POST", {
    ausfuehren,
  }, undefined, identity);
  if (
    !body ||
    typeof body.ausgefuehrt !== "boolean" ||
    !isZaehlung(body.geloescht) ||
    !isZaehlung(body.bleibt) ||
    typeof body.dateien !== "number"
  ) {
    throw new Error("Die Antwort des Servers hatte nicht die erwartete Form.");
  }
  return body as LoeschErgebnis;
}

export async function testdatenDatei(datei: TestdatenDatei, identity: WriteIdentity = captureWriteIdentity()): Promise<File> {
  assertWriteIdentity(identity);
  const blob = await getBlob(fillPath("/testdaten/dateien/{datei}", { datei }));
  assertWriteIdentity(identity);
  return new File([blob], datei, { type: MIME[datei] });
}
